import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DataLayerTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const userId = localStorage.getItem('user_id');
        // crm_id пока не передаём — не ясно, откуда брать

        if (window.dataLayer) {
            window.dataLayer.push({
                'pageview': {
                    // 'subject': {
                    //     'user_id': userId || '',
                    //     // 'crm_id': crmId,
                    // },
                    // 'object': location.pathname   
                    'location': location.pathname,
                  
                },
                'user_id': userId || ''
            });
        }
    }, [location]);

    return null;
};

export default DataLayerTracker; 